module.exports = __webpack_public_path__ + "ac0dbd11b717d4a07f6eb8482ffecea1.svg";